/* unplugin-vue-components disabled */
import $profile from 'stores/profile'

export default {
  mixins: [ModelValue(Boolean)],
  computed:{
    company(){
      return $profile.company_name || $profile.company_site
    },
  },
  methods: {
    handleDropdown(val){
      this.value = val.shared
    }
  }
}
